import React, {PropsWithChildren, useEffect, useMemo, useState} from 'react';
import { PermissionContext } from './permission.context';
import { useOidc } from '@revenuewell/logic-oidc';

export const PermissionProvider: React.FC<PropsWithChildren> =
  ({ children}) => {

  const {getClaims} = useOidc();
  const [permissions, setPermissions] = useState<number[]>([]);

  useEffect(() => {
      getClaims().then((c) => {
        if (c.permissions) {
          setPermissions(c.permissions)
        }
      })
    },
    [getClaims]);


  const context = useMemo(() => {
    return {
      hasPermission: (permission: number) => permissions.find(item => item === permission) !== undefined
    }
  }, [permissions])

  return (
    <PermissionContext.Provider value={context}>
      {children}
    </PermissionContext.Provider>
  )
}
